import React, { PureComponent } from "react";
import { connect } from "react-redux";
import build from "redux-object";
import { debounce, get, isEmpty } from "lodash";

import { fetchDiscount, updateDiscount } from "../../actions/discounts.actions";

import { getResourceById } from "../../reducers/resources.reducer";
import DiscountForm from "./DiscountForm";
import { fetchProductOptions } from "../../actions/products.actions";
import { fetchProductGroups } from "../../actions/product-groups.actions";
import { fetchCustomerGroups } from "../../actions/customer-groups.actions";
export class EditDiscount extends PureComponent {
  state = {};

  componentDidMount() {
    const { id } = this.props.match.params;

    this.props.dispatch(fetchDiscount(id)).then(() => {
      const { discount } = this.props;

      this.fetchNeededProductOptionsOnly(discount.discountableProductType);
      this.fetchNeededCustomerOptionsOnly(discount.discountableCustomerType);
    });
  }

  fetchNeededProductOptionsOnly = type => {
    switch (type) {
      case "Product":
        return this.props.dispatch(fetchProductOptions());
      case "ProductGroup":
        return this.props.dispatch(fetchProductGroups());
      default:
        return;
    }
  };

  fetchNeededCustomerOptionsOnly = type => {
    switch (type) {
      case "CustomerGroup":
        return this.props.dispatch(fetchCustomerGroups());
      default:
        return;
    }
  };

  static getDerivedStateFromProps(nextProps, state) {
    const { discount, products, productGroups, customerGroups, tenantSlug } = nextProps;

    const nextState = { tenantSlug };

    if (!isEmpty(discount) && isEmpty(state.discount)) nextState.discount = discount;

    if (!isEmpty(products) && isEmpty(state.productOptions)) {
      nextState.productOptions = products.map((product, index) => ({
        key: product.id,
        text: product.name,
        value: product.id,
        "data-test": `productOption-${index}`
      }));
    }

    if (!isEmpty(productGroups) && isEmpty(state.productGroupOptions)) {
      nextState.productGroupOptions = [].concat(
        productGroups
          .filter(productGroup => productGroup.id !== tenantSlug)
          .map((productGroup, index) => ({
            key: productGroup.id,
            text: productGroup.name,
            value: productGroup.id,
            "data-test": `productGroupOption-${index}`
          }))
      );
    }

    if (!isEmpty(customerGroups)) {
      nextState.customerGroupOptions = [{ key: tenantSlug, text: "All Customers", value: tenantSlug }].concat(
        customerGroups
          .filter(customerGroup => customerGroup.id !== tenantSlug)
          .map((customerGroup, index) => ({
            key: customerGroup.id,
            text: customerGroup.name,
            value: customerGroup.id,
            "data-test": `customerGroupOption-${index}`
          }))
      );
    }

    return { ...state, ...nextState };
  }

  appliesOnProduct = () => {
    if (isEmpty(this.props.products)) this.props.dispatch(fetchProductOptions());
  };

  appliesOnProductGroup = () => {
    if (isEmpty(this.props.productGroups)) this.props.dispatch(fetchProductGroups());
  };

  appliesForCustomerGroup = () => {
    this.props.dispatch(fetchCustomerGroups());
  };

  saveDiscountChanges = discount => {
    const { slug } = discount;
    this.props.dispatch(updateDiscount(slug, { discount }));
  };

  render() {
    const { discount, productOptions, productGroupOptions, customerGroupOptions, tenantSlug } = this.state;

    return (
      <DiscountForm
        page="Edit"
        tenantSlug={tenantSlug}
        discount={discount}
        appliesOnProduct={this.appliesOnProduct}
        appliesOnProductGroup={this.appliesOnProductGroup}
        appliesForCustomerGroup={this.appliesForCustomerGroup}
        productOptions={productOptions}
        productGroupOptions={productGroupOptions}
        customerGroupOptions={customerGroupOptions}
        saveDiscountChanges={this.saveDiscountChanges}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { id } = props.match.params;

  return {
    tenantSlug: get(state, "common.currentTenant.slug"),
    discount: getResourceById(state, id),
    products: build(get(state, "products.productOptions", {}) || {}, "products", null, {
      ignoreLinks: true
    }),
    productGroups: build(get(state, "productGroups", {}), "productGroups", null, {
      ignoreLinks: true
    }),
    customerGroups: build(get(state, "resources.list", {}), "customerGroups", null, {
      ignoreLinks: true
    })
  };
};
export default connect(mapStateToProps)(EditDiscount);
